import { CERequirementAttributesBase } from './ce-requirement-attributes-base'


export class CERequirementAttributes extends CERequirementAttributesBase {

}